export default __webpack_public_path__ + "assets/images/3d.png";